export const css = {
    root: 'HvLAhfMW',
    flexContainer: 'mynepViq',
    label: 'xHqbtnj8',
    output: 'mAV9vkdV',
    progress: 'GRBJbCTk',
    ' _key': 'mc-widgets/progress'
};
export default css;
